import i18n from '~/locales/i18next';

export const API_DEFAULT_CONTENT_TYPE = 'application/json';
export const API_DEFAULT_TIMEOUT = 300000;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
};

export const GMOASK_STATUS = {
  OK: 0,
  VALIDATION_SHOW_MESSAGE_MAX: -1000, // 範囲の比較に用いることが主なので数値型にしておく
  VALIDATION_SHOW_MESSAGE_MIN: -1999, // 範囲の比較に用いることが主なので数値型にしておく
  BAD_REQUEST: '-400',
  UNAUTHORIZED: '-401',
  FORBIDDEN: '-403',
  NOT_FOUND: '-404',
  INTERNAL_SERVER_ERROR: '-500',
  TABULATION_NOT_EXECUTED: -1100,
};

// フロント側でエラーメッセージを表示すべきエラー用。
// APIのエラーステータスコードと表示メッセージのマップ。
export const ERROR_CODE_MESSAGE_MAP = {
  '-1001': i18n.t('validation.signinError'),
  '-1002': i18n.t('validation.sigininLockError'),
};

export const ORIGINS = {
  GMOASK_BFF: process.env.REACT_APP_ORIGINS_GMOASK_BFF,
  SIMPLE_SURVEY: process.env.REACT_APP_ORIGINS_SIMPLE_SURVEY,
};

export const CSRF_TOKEN_NAME = process.env.REACT_APP_CSRF_TOKEN_NAME;
